import { Play, Volume2 } from 'lucide-react';
import { useRef, useState } from 'react';

const FilmSection = () => {
  const videoRefs = useRef([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const films = [
    {
      video: "https://ik.imagekit.io/p3xaqnkci/tagteam/films/film1.mp4",
      title: "Fashion Editorial",
    },
    {
      video: "https://ik.imagekit.io/p3xaqnkci/tagteam/films/film2.mp4",
      title: "Heritage Portrait",
    },
    {
      video: "https://ik.imagekit.io/p3xaqnkci/tagteam/films/film3.mp4",
      title: "Tradition in Motion",
    },
    {
      video: "https://ik.imagekit.io/p3xaqnkci/tagteam/films/film4.mp4",
      title: "Styled Moments",
    },
  ];

  const handleVideoClick = (index) => {
    const video = videoRefs.current[index];
    if (!video) return;

    if (activeIndex === index) {
      video.muted = true;
      video.volume = 0;
      setActiveIndex(null);
      return;
    }

    videoRefs.current.forEach((v) => {
      if (!v) return;
      v.muted = true;
      v.volume = 0;
    });

    video.muted = false;
    video.volume = 1;
    video.play();
    setActiveIndex(index);
  };

  return (
    <section id="films" className="bg-neutral-950 py-12 sm:py-16 lg:py-22 overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-12">

        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 sm:gap-6 mb-8 sm:mb-10">
          <div>
            <span className="text-[#d4af37] text-[10px] tracking-[0.5em] block mb-2">
              CINEMATIC VISUALS
            </span>
            <h2 className="text-2xl sm:text-3xl lg:text-5xl text-white font-serif font-light">
              Creative <span className="italic text-neutral-500">Reels</span>
            </h2>
          </div>

          <p className="text-neutral-500 text-xs sm:text-sm leading-relaxed max-w-xs sm:max-w-md sm:text-right">
            Fashion visuals, brand stories, music videos—crafted with
            intention, rhythm, and cinematic precision.
          </p>
        </div>

        {/* Video Grid - Responsive */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4">
          {films.map((film, i) => (
            <div
              key={i}
              className="cursor-pointer relative group"
              onClick={() => handleVideoClick(i)}
              onMouseEnter={() => setHoveredIndex(i)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              {/* Video Container */}
              <div className="aspect-[3/4] sm:aspect-[9/14] overflow-hidden relative rounded-sm">
                <video
                  ref={(el) => (videoRefs.current[i] = el)}
                  autoPlay
                  loop
                  muted
                  playsInline
                  preload="metadata"
                  className={`w-full h-full object-cover transition-all duration-700 
        ${hoveredIndex === i ? 'scale-105' : 'scale-100'}
        brightness-100`}
                >
                  <source
                    src={film.video}
                    type="application/x-mpegURL"
                  />
                </video>

                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-neutral-950 via-transparent to-neutral-950/30 opacity-60" />

                {/* Top Index Badge */}
                <div className="absolute top-2 sm:top-3 left-2 sm:left-3">
                  <span className="text-[#d4af37]/60 text-[9px] sm:text-[10px] tracking-widest font-mono">
                    0{i + 1}
                  </span>
                </div>

                {/* Sound Indicator */}
                <div className={`absolute top-2 sm:top-3 right-2 sm:right-3 transition-opacity duration-300 
                  ${activeIndex === i ? 'opacity-100' : 'opacity-0'}`}>
                  <Volume2 className="w-3 h-3 text-[#d4af37]" />
                </div>

                {/* Center Play Icon */}
                <div className={`absolute inset-0 flex items-center justify-center transition-opacity duration-300
                  ${hoveredIndex === i && activeIndex !== i ? 'opacity-100' : 'opacity-0'}`}>
                  <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full border border-white/40 flex items-center justify-center 
                    backdrop-blur-sm bg-neutral-950/20">
                    <Play className="w-2.5 h-2.5 sm:w-3 sm:h-3 text-white ml-0.5" />
                  </div>
                </div>

                {/* Bottom Title */}
                {/* <div className="absolute bottom-0 left-0 right-0 p-2 sm:p-4">
                  <span className={`text-[10px] sm:text-xs tracking-[0.15em] sm:tracking-[0.2em] transition-colors duration-300
                    ${activeIndex === i ? 'text-[#d4af37]' : 'text-white/70'}`}>
                    {film.title.toUpperCase()}
                  </span>
                </div> */}

                {/* Active Border */}
                <div className={`absolute inset-0 border transition-all duration-500 rounded-sm pointer-events-none
                  ${activeIndex === i ? 'border-[#d4af37]/50' : 'border-transparent'}`} />
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default FilmSection;